import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {k} from "@angular/core/src/render3";

export class UserProgram {
  question1: number;
  question2: number;
  moodTracking: boolean;
  weightTracking: boolean;
  foodTracking: boolean;
  stepTracking: boolean;
  backpainTracking: boolean;
  backpainLevel: number;
  trainingDays: number;
  trainingNotification: boolean;
}

export class UserInsurance {
  firstName: string;
  lastName: string;
  type: string;
  aokId: string;
  birthDate: string;
}

/*
  Generated class for the UserStateProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export class User {
  id: String;
  stepCounterEngine: string;
  email: string;
  firstName: string;
  createdAt: string;
  status: number;
  prescriptionCode: string;
  program: UserProgram;
  insurance: UserInsurance;
  locked: boolean;
  activityTarget: number;
  lastActivityTargetUpdate: string;
  activityDays: number;
  surveyToken: number;
  playerIssues: boolean;
  partnerSelected: boolean;
  partnerData: {
    id: string,
    name: string,
    surname: string,
    title: string,
    avatarUrl: string,
    profession: string,
    chat: boolean
  };
  introWatched: boolean;
  started: boolean;
  additionalData: string;
  pauseStartDate: string;
  pauseEndDate: string;
  challengeStatus: number;
}

@Injectable()
export class UserStateProvider {

  user: User;
  token: string;

  constructor(public http: HttpClient) {
    console.log('Hello UserStateProvider Provider');
  }

  getAdditionalParam(key: string) {
    let data = this.user.additionalData;
    try {
      let serializedData = JSON.parse(data);
      if(serializedData[key] != undefined) {
        return serializedData[key];
      }
    } catch(e) {
      return null;
    }
    return null;
  }

  setAdditionalParam(key: string, value: any) {
    let data = this.user.additionalData;
    let serializedData = {}
    try {
      let parsedData = JSON.parse(data);
      if(typeof parsedData === 'object' && parsedData !==null) {
        serializedData = parsedData;
      }
    } catch(e) {
    }
    serializedData[key] = value;
    this.user.additionalData = JSON.stringify(serializedData);
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-state/user-state.ts